import Vue from 'vue';
let $store = null;
let $store2 = null;

const storeTemplate = {
	data(){
		return {
			addrOptions: [], //地址信息
			queryQueue: [], //请求队列
			queueInterval:null, //队列计时器
			isQuery:false, // 是否正在查询地址信息
		}
	},
	methods:{
		/**
		 * @method：addToQueue
		 * @createdBy:黄健
		 * @date:2020/1/8
		 * @params path：路径
		 * @description：添加到请求队列
		 */
		addToQueue(path){
			if(this.queryQueue.indexOf(path)>-1) return;
			this.queryQueue.push(path);
			if(this.queryQueue.length && !this.queueInterval){
				this.queueInterval = setInterval(()=>{
					if(!this.queryQueue.length){
						clearInterval(this.queueInterval);
						this.queueInterval = null;
						return;
					}
					if(this.isQuery) return;
					const nextPath = this.queryQueue.shift();
					this.loadByPath(nextPath);
				},50);
			}
		},
		/**
		 * @method：loadByPath
		 * @createdBy:黄健
		 * @date:2020/1/8
		 * @params path：路径
		 * @description：按路径加载省市区
		 */
		async loadByPath(path){
			if(this.isQuery){
				this.addToQueue(path);
				return;
			}
			this.isQuery = true;
			let addrOptions = [...this.addrOptions];
			const levels = (path || '').split('/');
			try {
				if(addrOptions.length < 1){
					const purl = `/${LinkVue.prefixUrl}/address/provinceList`;
					const provinces = await this.$http.post(purl, {});
					if(Array.isArray(provinces)){
						provinces.forEach((t)=>{
							if(t.addrType !== 'State' || t.active !=='Y') return;
							addrOptions.push({
								label: t.addrName,
								value: t.addrName,
								children: []
							});
						})
					}
				}

				const stateName = levels[0] || '';
				const state = addrOptions.find((t)=>stateName && t.value === stateName);
				let cityList = (state || {}).children;

				if(state && cityList && !cityList.length){
					const curl = `/${LinkVue.prefixUrl}/address/queryAddressListSelect`;
					const params = {
						parentAddrName: stateName,
						addrType: 'City'
					}
					const cities = await this.$http.post(curl, params, true);
					if(Array.isArray(cities)){
						cities.forEach((t)=>{
							if(t.addrType !== 'City' || t.active !=='Y') return;
							cityList.push({
								label: t.addrName,
								value: t.addrName,
								children: []
							});
						});
						state.children = cityList;
						if(!cityList.length){
							delete state.children;
							state.leaf = true;
						}
					}
				}

				const cityName = levels[1] || '';
				const city = (cityList || []).find((t)=>cityName && t.value === cityName);
				let countyList = (city || {}).children;
				if(city && countyList && !countyList.length){
					const durl = `/${LinkVue.prefixUrl}/address/queryAddressListSelect`;
					const params = {
						parentAddrName: cityName,
						addrType: 'County'
					};
					const counties =  await this.$http.post(durl, params, true);
					if(Array.isArray(counties)){
						counties.forEach((t)=>{
							if(t.addrType !== 'County' || t.active !=='Y') return;
							countyList.push({
								label: t.addrName,
								value: t.addrName
							});
						});
						city.children = countyList;
						if(!countyList.length){
							delete city.children;
							city.leaf = true;
						}
					}
				}
				this.addrOptions = [...addrOptions];
			}catch (e) {
				linkLog.error(e);
				this.$message.error(String(e));
			}
			this.isQuery = false;
		}
	}
}


/**
 * @method：getStore
 * @createdBy:黄健
 * @date:2020/1/8
 * @params：
 * @description：获取缓存器
 */
export function getStore(context) {
	if ($store && $store.$http === context.$http) {
		return $store
	} else if ($store2 && $store2.$http === context.$http) {
		return $store2
	} else if(!$store) {
		$store = new Vue(storeTemplate);
		$store.$http = context.$http
		return $store
	} else if(!$store2) {
		$store2 = new Vue(storeTemplate);
		$store2.$http = context.$http
		return $store2
	}
	console.warn('未找到完全匹配基础地址实例', context)
	// if(!$store){
	// 	$store = new Vue(storeTemplate);
	// }
	return $store;
}


